<template>
  <div class="bottom">
    <div class="bottom-content">
      <p class="lxwm">联系我们</p>
      <div class="rightimg">
        <img src="../../assets/img/HomePage/head/qrcode.png">
        <p class="gz">关注微信公众号</p>
      </div>
      <div class="lefttext">
        <p class="dh">电话：+86 21 6161 2120</p>
        <p class="dz">地址：上海市虹口区广纪路738号2号楼601室</p>
      </div>
      <div class="righttext">
        <p class="swhz">商务合作：contactus@prowiser.net</p>
        <p class="jrwm">加入我们：hr@prowiser.net</p>
      </div>

    </div>
    <!--<div class="bh" >-->
      <!--<div class="ClearFix" >-->
        <!--<div class="FL">-->
          <!--<br>Copyright © 2015 PROWISER. All Rights Reserved.-->
        <!--</div>-->

        <!--<div class="FR">-->
          <!--<a  href="https://beian.miit.gov.cn">沪ICP备15015492号-1</a> | 公安部备案号：31010902002720-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="bh">
      <div class="bh_left">Copyright © 2019智进咨询版权所有</div>
      <div class="bh_right">  <a href="http://www.miitbeian.gov.cn">沪ICP备15015492号-1</a>沪公网安备 31010902002720</div></div>
  </div>
</template>

<script>


export default {
  name: 'Homebottom',
  data () {
    return {
      states:''

    }
  },
  created() {
    this.states = state;
  },

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"   scoped>

  .bottom {
     height: 100%;
    width: 100%;
    display: table;
    /*background:url('../../assets/img/HomePage/head/bottomimg.png') no-repeat;*/
    /*background-size:100% 100%;*/
    background-color: #222;
    padding: 0 20px;
    margin-left: -20px;
    color: #fff;
  }
  .el-footer{
    height: auto!important;
    line-height: inherit;
    /*background-color: #d3d5d8;*/

    .bottom-content{
      width: 66%;
      margin: auto;
      /*color: #000071;*/
      text-align: left;
       .lxwm{
         width: 70%;
         font-size: .31rem;
         float: left;
         font-weight: bold;
         margin: .2rem 0 0 0;
       }
        .lefttext {
          float: left;
          margin-right: 1rem;
          .dh{
            font-size:.25rem;
            margin: .1rem 0;
          }
          .dz{
            font-size:.25rem;
            margin: .1rem 0;
          }
        }
         .righttext{
           float: left;
           margin-right: 1rem;
           .swhz{
             font-size:.25rem;
             margin: .1rem 0;
           }
           .jrwm{
             font-size:.25rem;
             margin: .1rem 0;
           }
        }
      .rightimg{
        float: right;
        img{
          width:1.2rem;
          margin-top: .2rem;
          margin-left: 0.05rem;
        }
        .gz{
          font-size:.1875rem;
          /*color: #000;*/
          margin-top: 0;
           margin-bottom: 0;
          line-height: 0.1rem;
        }
      }
    }
    .bh{
      /*top:100%;*/
      /*width: 100%;*/
      /*color: #000;*/
      /*padding: .25rem 0;*/
      /*margin: auto;*/
      /*margin-top: 1.8rem;*/
      /*margin-bottom: .4rem;*/
      /*.ClearFix{*/
        /*margin: 0 auto;*/
        /*width: 66%;*/
        /*.FL{*/
          /*color: #000;*/
          /*font-size: .21rem;*/
          /*line-height: .16rem;*/
          /*float: left;*/
        /*}*/
        /*.FR{*/
          /*color: #000;*/
          /*font-size: .21rem;*/
          /*line-height: .16rem;*/
          /*float: right;*/
          /*img{*/
             /*border: medium none;*/
             /*vertical-align: middle;*/
          /*}*/
          /*a{*/
              /*border-left: 1px solid #000;*/
            /*color: #000;*/
          /*display: inline-block;*/
          /*font-size: .21rem;*/
          /*line-height: .16rem;*/
          /*}*/
        /*}*/
      /*}*/

      font-size: .16rem;
      width: 66%;
      height: 0.3rem;
      margin: auto;
      margin-top: 2rem;
      margin-bottom: 0.2rem;
      .bh_left{
        float: left;
      }
      .bh_right{
        float: left;
        a{
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
        color: #fff;
        display: inline-block;
        font-size: .16rem;
          padding: 0 0.1rem;
          margin-left: 0.1rem;
          margin-right: 0.1rem;
          text-decoration:none
        }
      }
    }
  }

  @media screen and (max-width:750px){

    .bottom-content {
      width: 100%!important;
      .lefttext{
        margin-right: 0!important;
         .dh {
               margin:0!important;
             }
          .dz {
               margin:0!important;
             }
       }
      .righttext{
         margin-top: 0.2rem;
        margin-right: 0!important;
          .swhz {
               margin:0!important;
             }
          .jrwm {
               margin:0!important;
             }
       }

      .rightimg {
        img{
            width: 1.3rem!important;
            margin-top: .4rem!important;
          }

        }

    }
  .el-footer .bh {
    margin-top: 2.5rem;
    width:100%!important;
    font-size: .21rem;
    height: .8rem;
    .bh_left{
      float: inherit;
      margin: .1rem;
    }
    .bh_right{
      float: inherit;
       a{
         font-size: .21rem;
       }
    }

}
}

</style>



// WEBPACK FOOTER //
// src/components/brand-products/bottom.vue